import { useDebouncedEffect } from '@clover-util/use-debounced-effect';
import { useState } from 'react';
export const WAIT = 50;
export function useResolvedState(request, cancel) {
    const [state, setState] = useState({});
    useDebouncedEffect(() => {
        request === null || request === void 0 ? void 0 : request().then(value => { if (value !== undefined && value !== null)
            setState({ value }); }, error => setState({ error }));
        return cancel;
    }, WAIT, [request, cancel]);
    return Object.assign([state.value, state.error], state);
}
//# sourceMappingURL=useResolvedState.js.map